import _ from 'lodash';

export function nl2brFilter() {
	'ngInject';
	return function (text) {
		// ngSanitize's linky filter changes \r and \n to &#10; and &#13; respectively
		return _.escape(text || '')
			.trim()
			.replace(/(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)/g, '<br />$1');
	};
}

export function nl2ParagraphsFilter() {
	'ngInject';
	return function (text) {
		// ngSanitize's linky filter changes \r and \n to &#10; and &#13; respectively
		return (
			'<p>' +
			_.escape(text || '')
				.trim()
				.replace(/(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)+/g, '</p><p>') +
			'</p>'
		).replace(/<p><\/p>/g, '');
	};
}
